import Rails from "@rails/ujs";

$(function() {
  Rails.start();
});
